<template>
    <poverty-visualization :charts="charts" :area-chart="areaChart" :line-chart="lineChart" :title="title"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Porcentaje de personas en situación de pobreza por ingresos',
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQs6f2f91_HpnLcVyN8SIkUKbeh4fgx-A-neQ__5yYmAV1q0U2pRK_Q_L7vTQ_pPH0HqamuU1VZ_I70/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTulNaJvbdrF6XIe3v9BETMgC6Y4pcYI0xpGVuhoAjf00S13PYVaUCQuwa1MJ41a52DdxxadGN2OuH9/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','zona']
                    },
                    {
                        id: 'genero',
                        title: 'Género',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT3E1FAWLwX8sCQDm02cmdfBhL-AHKVlipZAoD-tsVZn8sxbLmPjNSTSSadHxA0Gw2fZb9MZBrFe0XF/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTfiVKGc6otvobKStb_Sdo6YzxiqBKlLOtIV_P8GucbuqB0SvfOHFrX57N5I2V5KO0yeME6vTcKyioV/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','genero']
                    },
                    {
                        id: 'edades',
                        title: 'Rangos Etarios',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRhfVubH8ksyDyloTnTxSHrbjia8h4MNWT1TalOmHGy_bEfOHcTdRA--jY2N5rdalA-kYubvNO1mXtP/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRq2QUw-nyeI5mWVcvx-fZadg3Q8J_lwRfmer6v9FMYW_yFQaJVixK4BjpNKTjY-hrjumCm4clVGOZw/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','edades']
                    },
                    {
                        id: 'migrantes',
                        title: 'Migrantes',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSiJqOmMFlbn-Lw-qVKUufGLQHHVWZ1qaMuzH9GFW7MQTDghnaELWucHtoj2LpzBKl-gzeBJhBUAtIW/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRZjJ4laoEgGPH3xD8Ivj7QsCQrM0Md3pvO3HU3HMS20ycjmRJ7A4tuwbrbhJmelrgIJ7uaCKUToMIB/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','migrantes']
                    },
                    {
                        id: 'pueb_indig',
                        title: 'Pueblos Indigenas',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRsS8bwMm5f_h0FnxEH-GQOyA_HZ-sGJf5Uco-uRNf8WioFgqezTsSQ2o8PhNcSTY-LVAmamS94fbAG/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSR5Hrln8Wer0LdheTMZ1a4dM3ASJq55ocBWh4yIMPycxKl2b3CgSM7Ct7IC-vhZ8lkq66WgENgLEvP/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','pueb_indig']
                    },
                    {
                        id: 'quintil',
                        title: 'Quintiles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRmJz0fgyC6PAiCP_AgSKv7euQMkWgfPQkankYJXx28tDKoOw0tf_4sp3E-W862kaE82Q-lryiZqpqP/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSSONFpI-FA5dlXA_iEDYs1vlkeqBAJ_3ZVggQ2Y2nArEW35-XPF3_ttr4K6DSCqrl1uEWg1g6DmWbb/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','quintil']
                    }
                ],
                areaChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQhJ7IXrzY2V8piFe-LcWEZLtu_Op8OaNEdSNrigwgtN5ySzOwEsH88FDn0641aONb8WweQId-EhsZU/pub?gid=0&single=true&output=csv'
                },
                lineChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTDrgPKkeT8ssrey3K3YeOiJm22KU4pCEp5kvga89jJtiqJhmO65Zq3PKc53niibUXT-706dliEcJa-/pub?gid=0&single=true&output=csv'
                }
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/PovertyIncomeVisualization.vue